import { LOCAL_STORAGE_KEYS } from 'config/Vars'

import useLocalStorage from 'modules/core/lib/useLocalStorage'

/**
 * Hook to manage virtual background settings
 */
export function useVirtualBackgroundSettings() {
  const [backgroundType, setBackgroundType] = useLocalStorage<string>(
    LOCAL_STORAGE_KEYS.meetingVirtualBackgroundEnabled,
    'blur' // Default to blur
  )

  return {
    backgroundType,
    setBackgroundType,
  }
}
